// routes/ErrorRoutes.jsx
import { lazy } from 'react';
import Loadable from '../Components/Loadable.js';
const ErrorPage = Loadable(lazy(() => import('../Components/ErrorPage/ErrorPage.js')));
const Unauthorized = Loadable(lazy(() => import('../Components/Unauthorized/Unauthorized.jsx')));

const ErrorRoutes = {
  path: '/',
  children: [
    { path: 'unauthorized', element: <Unauthorized /> },
    { path: '*', element: <ErrorPage /> }
  ]
};

export default ErrorRoutes;
